import React, { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { IonPage, IonContent, IonCard, IonCardContent, IonList, IonText, IonCardTitle } from '@ionic/react'

import Toolbar from '../components/Toolbar'
import ItemSinal from '../components/ItemSinal'
import ItemWordSearch from '../components/ItemWordSearch'

import WordService from '../services/WordService'
import signalService from '../services/SignalService'

import { Word } from '../models/Word'
import { Sinal } from '../models/Sinal'

import { DETAILS_WORD_ROUTER } from '../Routers'


const SinalDetails: React.FC = () => {
  const location = useLocation()
  const history = useHistory();

  const [words, setWords] = useState<Word[]>();
  const [signal, setSignal] = useState<Sinal>()

  function showWord(word: Word) {
    history.push(`${DETAILS_WORD_ROUTER}?wordId=${word.key}`)
  }

  const fetchSignal = useCallback(async (signalId: string) => {
    const signal = signalService.getSignalById(signalId);

    setSignal(signal)
  }, [])

  const fetchWords = useCallback(async (signalId: string) => {
    WordService.getWordsBySinal(signalId)
      .then(words => {
        console.log(words)
        setWords(words);
      })
      .catch(err => console.error(err))
  }, [])

  useEffect(() => {
    const signalId = new URLSearchParams(location.search).get('sinalId')

    if (signalId) {
      fetchSignal(signalId);
      fetchWords(signalId);
    }

  }, [fetchSignal, fetchWords, location.search])

  return (
    <IonPage>
      <Toolbar title="Detalhes do Sinal" infoBtn={false} menuBtn={true} />
      <IonContent >
        <ItemSinal sinal={signal} />

        <IonCardContent>
          <IonCardTitle>Palavras que utilizam o sinal</IonCardTitle>
          <IonList>
            {words?.map(word =>
              <ItemWordSearch key={word.key} word={word} onClick={() => showWord(word)} />
            )}
          </IonList>
          {
            (!words || words.length === 0) &&
            <IonCard>
              <IonCardContent className="ion-text-center">
                <IonText>Nenhum resultado encontrado.</IonText>
              </IonCardContent>
            </IonCard>
          }
        </IonCardContent>
      </IonContent>
    </IonPage>
  )
}

export default SinalDetails
